import * as React from 'react';
import useFetchSmartSuggest from 'PyzShopUi/scripts/search-suggestion/hooks/useFetchSmartSuggest';
import useHandleScrollEffect from 'PyzShopUi/scripts/search-suggestion/hooks/useHandleScrollEffect';
import MostPopularList from 'PyzShopUi/scripts/search-suggestion/components/suggestion/smart-suggest/MostPopularList';
import QueryList from 'PyzShopUi/scripts/search-suggestion/components/suggestion/smart-suggest/QueryList';
import PlainLayout from 'PyzShopUi/scripts/search-suggestion/components/screen/PlainLayout';

interface ISmartSuggestContainerProps {
    isVisible: boolean;
    isSmallScreen: boolean;
    searchValue: string;
    minSearchStringLengthToGetData: number;

    onClose(): void;
}

const SmartSuggestContainer: React.FunctionComponent<ISmartSuggestContainerProps> = props => {
    const {
        searchValue,
        minSearchStringLengthToGetData,
        isVisible,
        isSmallScreen,
        onClose
    } = props;

    const { suggestions, isLoading } = useFetchSmartSuggest(searchValue, minSearchStringLengthToGetData);

    useHandleScrollEffect(isVisible, false, suggestions);

    const resultList = searchValue === '' ?
        <MostPopularList suggestionItems={suggestions}/> :
        <QueryList suggestions={suggestions} searchValue={searchValue}/>;

    return (
        <PlainLayout
            suggestions={suggestions}
            isLoading={isLoading}
            isVisible={isVisible}
            isSmallScreen={isSmallScreen}
            onClose={onClose}>
            {resultList}
        </PlainLayout>
    );
};

SmartSuggestContainer.defaultProps = {
    searchValue: '',
};

export default SmartSuggestContainer;
